import React, {createContext, useContext, useState, ReactNode} from 'react';


interface ProductContextType {
    product: string;
    setProduct: React.Dispatch<React.SetStateAction<string>>;
}

interface ProductProviderContext {
    children: ReactNode;
}

const ProductContext = createContext<ProductContextType | undefined>(undefined);


export const ProductProvider: React.FC<ProductProviderContext> = ({children}) => {
    const [product, setProduct] = useState<string>('');
    const [isBulkDiscount, setIsBulkDiscount] = useState<boolean>(false);

    const changeBulkDiscountStatus  = () => {
        setIsBulkDiscount((true));
    }

    
    const contextValue = {
        product,
        setProduct,
        isBulkDiscount,
        changeBulkDiscountStatus
    };

    return (
        <ProductContext.Provider value={contextValue}>
            {children}
        </ProductContext.Provider>
    );
};

export const useProduct = (): any => {
    const context = useContext(ProductContext);
    if (context === undefined) {
        throw new Error('useProduct must be used within a ProductProvider');
    }
    return context;
};
